import { AppConstant } from './../../../../utilities/app.constants';
import { Component, OnInit, ViewChild, ElementRef, OnChanges } from '@angular/core';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { CustomDialogService } from 'src/app/shared/custom-dialog.service';
import { Location, DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AppSpinnerService } from 'src/app/services/app-spinner.service';
import {
  debounceTime,
  map,
  distinctUntilChanged,
  filter
} from 'rxjs/operators';
import { Subject, BehaviorSubject } from 'rxjs';
import * as xlsx from 'xlsx';
//import * as jsPDF from 'jspdf';
//import * as html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import autoTable from 'jspdf-autotable';
import { FilterService } from 'src/app/services/filter.service';
import { CrewDataService } from 'src/app/services/crew-data.service';
import { SettingsService } from 'src/app/services/settings.service'


@Component({
  selector: 'app-crew-ratings-detail',
  templateUrl: './crew-ratings-detail.component.html',
  styleUrls: ['./crew-ratings-detail.component.scss']
})

export class CrewRatingsDetailComponent implements OnInit, OnChanges {

  chartType = 'lineChart';

  @ViewChild('lineChart', { static: false }) lineChart: ElementRef;
  fullRecordFlag = false;
  ratingMasterInfo: any;
  period = 'Last 1 Month';
  crewRatings: any = [];
  intialRatings: any = [];
  crewRanks: any = [];
  noOfReports = 0;
  noOfShips = 0;
  averageRating:any = 0;
  userInfo: any = {};
  crewName: string;
  crewId: string;
  rank = 'current';
  msg: string;
  suggestedCrewMember = [];
  suggestedcrewMemberListLength = 0;
  suggestedCrewMemberData = [];
  ratingList: any;
  pdfRatings;
  departmentCategoryRankList = [];
  private subject: Subject<string> = new Subject();
  private subjectId: Subject<string> = new Subject();
  head = [['Vessel Name', 'Rank', 'Date of Report', 'Safety Rating']]
  tableData = [];
  category: string;
  department: string;
  outlier: boolean = false;

  constructor(
    readonly analyticsService: AnalyticsService,
    private crewService: CrewDataService,
    private readonly customDialogService: CustomDialogService,
    private readonly location: Location,
    private readonly activatedRoute: ActivatedRoute,
    public appSpinner: AppSpinnerService,
    private filterService: FilterService,
    public datepipe: DatePipe,
    public settingsService: SettingsService, 
    private router: Router
  ) {
    this.getDepartCategoryRank();
    this.settingsService.getSubmitterDetailViewStatus().subscribe((data : any) => {
      console.log('Set data ',data);
      if(data){
        this.settingsService.setEmailAddress(data.submitterEmailAddressArray);
      }
    })
   }

   setChartType(chartType: string) {
    this.chartType = chartType;
  }

  ngOnInit() {
	setTimeout(() => {
      this.loadSelectedCrewDetails();
    }, 500);

   
    
    // this.ratingMasterInfo = this.analyticsService.getSelectedRating();
    // if (this.ratingMasterInfo) {
    //   this.noOfReports = this.ratingMasterInfo.noOfReports;
    //   this.noOfShips = this.ratingMasterInfo.uniqueVessel.length;
    //   this.averageRating = this.ratingMasterInfo.averageRating;

    // }


    this.subject.pipe(
      //filter(res => res.length>7),
      debounceTime(700),
      // distinctUntilChanged()
    ).subscribe(searchTextValue => {
      this.getCrewListByCrewName(searchTextValue);
    });

    this.subjectId.pipe(
      debounceTime(1000),
      // distinctUntilChanged()
    ).subscribe(crewId => {
      this.listCrewRating(crewId);
      this.fetchCrewRatings(crewId);
      this.fetchCrewRanks(crewId);
    });
  }

  ngOnChanges() {
  }

  valueProvided($event, check) {
    this.outlier = check;
    const crewId = this.activatedRoute.snapshot.paramMap.get('crewId');
    this.listCrewRating(crewId);
    this.fetchCrewRatings(this.crewId);
  }

  getCrewRatingListPDF(crewRatings) {
    this.tableData = [];
    this.ratingList = crewRatings;
    for (let i = 0; i < this.ratingList.length; i++) {
      const date = this.datepipe.transform(this.ratingList[i].createdAt, 'dd-MM-yyyy');
      let avgRatingList = this.ratingList[i].finalRating == 0 ? '-' : parseFloat(this.ratingList[i].finalRating).toFixed(2);
      let robject = [
        this.ratingList[i].vesselName,
        this.ratingList[i].rank,
        date,
        avgRatingList
      ]
      this.tableData.push(robject);
      console.log('this.tableData', this.tableData);
    }
  }

  loadSelectedCrewDetails() {
    const crewId = this.activatedRoute.snapshot.paramMap.get('crewId');
    this.listCrewRating(crewId);
    this.fetchCrewRatings(crewId);
    this.fetchCrewRanks(crewId);
  }

  listCrewRating(crewId: string) {
    if (crewId) {
      this.analyticsService.listCrewRatings(crewId, this.rank,this.outlier).subscribe((crewRating: any) => {
        console.log('crewRating[0]', crewRating);
        if (crewRating && crewRating.length > 0) {
          this.noOfReports = crewRating[0].noOfReports;
          this.noOfShips = crewRating[0].uniqueVessel.length;
          this.averageRating = crewRating[0].averageRating;
          this.userInfo = crewRating[0].userInfo;
          this.crewName = this.userInfo.firstName + ' ' + this.userInfo.anotherName;
          this.crewId = this.userInfo.crewId;
          this.category = this.userInfo.category;
          this.department = this.userInfo.department;
          if (this.rank === 'current') {
            this.rank = this.userInfo.rank;
          }
        }
        else {

          this.averageRating = 0;
          this.noOfShips = 0;
          this.noOfReports = 0;
          this.userInfo = {};
          this.crewName = '';
          this.appSpinner.hide();
          this.msg = AppConstant.CREW_ID_NOT_FIND;
          // this.customDialogService.showDialog(this.msg, 'dismiss');
        }
      }, (error => {
        if (error.status == 404) {
          this.averageRating = 0;
          this.noOfShips = 0;
          this.noOfReports = 0;
          this.userInfo = {};
          this.crewName = '';
          this.appSpinner.hide();
          this.msg = AppConstant.CREW_ID_NOT_FIND;
          this.customDialogService.showDialog(this.msg, 'dismiss');
        }
      }))
    }
  }

  getCrewListByCrewName(crewName: string) {
    this.suggestedCrewMember = [];
    this.suggestedCrewMemberData = [];
    if (crewName) {
      console.log('crewName ', crewName);
      this.analyticsService.getCrewListByCrewName(crewName).subscribe((data: any) => {
        this.suggestedcrewMemberListLength = 0;
        this.suggestedCrewMember = [];
        this.suggestedCrewMemberData = [];
        for (let i = 0; i < data.length; i++) {
          this.suggestedCrewMember.push(data[i]);
          this.suggestedCrewMemberData.push(data[i].userInfo[0]);
        }
        this.suggestedcrewMemberListLength = this.suggestedCrewMember.length;
        console.log('data by name', this.suggestedCrewMember);
      })
    }
    else {
      this.averageRating = 0;
      this.noOfShips = 0;
      this.noOfReports = 0;
      this.userInfo = {};
      this.crewName = '';
      this.crewId = '';
      this.crewRatings = [];
    }

  }



  getCrewListByCrewNameSearch(crewName: string) {
    this.suggestedCrewMember = [];
    this.suggestedCrewMemberData = [];
    if (crewName) {
      console.log('crewName ', crewName);
      this.analyticsService.getCrewListByCrewName(crewName).subscribe((data: any) => {
        console.log('data by name',data);
        if (data && data.length > 0) {
          this.suggestedcrewMemberListLength = 0;
          this.suggestedCrewMember = [];
          this.suggestedCrewMemberData = [];
          for (let i = 0; i < data.length; i++) {
            this.suggestedCrewMember.push(data[i]);
            this.suggestedCrewMemberData.push(data[i].userInfo[0]);
          }
          this.suggestedcrewMemberListLength = this.suggestedCrewMember.length;
        }
        else {
          this.averageRating = 0;
          this.noOfShips = 0;
          this.noOfReports = 0;
          this.userInfo = {};
          this.crewName = '';
          this.msg = `Could not find the ${crewName} in the database`;
          this.customDialogService.showDialog(this.msg, 'dismiss');
        }
      }, (error => {
        console.log('error code ', error.status);
        if (error.status == 404) {
          this.averageRating = 0;
          this.noOfShips = 0;
          this.noOfReports = 0;
          this.userInfo = {};
          this.crewName = '';
          this.msg = `Could not find the ${crewName} in the database`;
          this.customDialogService.showDialog(this.msg, 'dismiss');
        }
      }))
    }
    else {
      this.averageRating = 0;
      this.noOfShips = 0;
      this.noOfReports = 0;
      this.userInfo = {};
      this.crewName = '';
      this.crewId = '';
      this.crewRatings = [];
      this.suggestedCrewMember = [];
      this.suggestedCrewMemberData = [];
      this.suggestedcrewMemberListLength = 0;
    }

  }


  async selectedNameForCrewMember(crewId) {
    this.tableData = [];
    this.ratingList = [];
    for (let i = 0; i < this.suggestedCrewMember.length; i++) {
      if (this.suggestedCrewMember[i]._id === crewId) {
        console.log('selected ', this.suggestedCrewMember[i]);
        // this.noOfReports = this.suggestedCrewMember[i].noOfReports;
        // this.noOfShips = this.suggestedCrewMember[i].uniqueVessel.length;
        // this.averageRating = this.suggestedCrewMember[i].averageRating;
        // this.userInfo = this.suggestedCrewMember[i].userInfo[0];
        // this.crewName = this.userInfo.firstName + ' ' + this.userInfo.anotherName;
        this.crewId = this.userInfo.crewId;
        // this.rank = this.userInfo.rank;
        this.rank = 'current';
        await this.listCrewRating(crewId);
        await this.fetchCrewRatings(crewId);
        await this.fetchCrewRanks(crewId);
        this.suggestedcrewMemberListLength = 0;
      }
    }
  }



  onSearchByCrewId(searchTextValue: string) {
    console.log('hit');

    if (searchTextValue) {
      this.subjectId.next(searchTextValue);
    }
    // else{
    //   console.log('hit else2');
    //   this.loadSelectedCrewDetails();
    // }
  }

  onSearch(searchTextValue: string) {
    if (searchTextValue) {
      this.rank = 'current';
      this.subjectId.next(searchTextValue);
    }
    // else{
    //   console.log('hit else2');
    //   this.loadSelectedCrewDetails();
    // }
  }

   fetchCrewRatings(crewId: string) {
    this.crewId = crewId;
    this.location.go('/analytics/crew-ratings-detail/' + crewId);
    this.appSpinner.show();
    this.analyticsService.getCrewRatings(crewId, this.rank,this.outlier).subscribe((ratings: any) => {
      console.log('rating ', ratings);
      this.crewRatings = ratings;
      this.intialRatings = [...this.crewRatings];
      console.log('this.intialRatings', this.intialRatings);
      this.appSpinner.hide();
    }, (error) => {
      this.appSpinner.hide();
      this.crewRatings = [];
    });
  }

  getDepartCategoryRank(){
    this.crewService.getDepartmentCatRank().subscribe((data: any) =>{
      this.departmentCategoryRankList = data;
    })
  }

  sortFetchedCrewRanks(crewRanks){
    let allrankList = this.departmentCategoryRankList;
      let orderedCrewRanks = [];
      for(let index = 0 ; index < allrankList.length; index++){
        for(let subindex = 0; subindex < crewRanks.length; subindex++){
          if(allrankList[index].rank === crewRanks[subindex]){
            orderedCrewRanks.push(allrankList[index].rank);
            break;
          }
        }
      }
      console.log('sorted list ', orderedCrewRanks);
      return orderedCrewRanks;
    }
  
  fetchCrewRanks(crewId: string) {
    this.crewId = crewId;
    this.analyticsService.getCrewRanks(crewId).subscribe((ranks: any[]) => {
        console.log('crewRanks', ranks);
        this.crewRanks = ranks;
        if(this.crewRanks && this.departmentCategoryRankList.length > 0){
          this.crewRanks = this.sortFetchedCrewRanks(this.crewRanks);
        }
      }, (error) => {
        this.crewRanks = [];
      });
    }
  

  setChartView(chartView: boolean) {
    console.log('open');
    this.suggestedcrewMemberListLength = 0;
    this.analyticsService.isChartView = chartView;
  }

  onSelectPeriod(event) {
    const period = event.srcElement.value;
    const endDate = new Date();
    if (period === 'Last 1 Month') {
      let startDate = new Date();
      startDate = new Date(startDate.setMonth(startDate.getMonth() - 1));
      this.crewRatings = this.intialRatings.filter(rating => {
        const crewCreatedDate = new Date(rating.createdAt);
        return crewCreatedDate.getTime() >= startDate.getTime() && crewCreatedDate.getTime() <= endDate.getTime();
      });
    } else if (period === 'Last 3 Months') {
      let startDate = new Date();
      startDate = new Date(startDate.setMonth(startDate.getMonth() - 3));
      this.crewRatings = this.intialRatings.filter(rating => {
        const crewCreatedDate = new Date(rating.createdAt);
        return crewCreatedDate.getTime() >= startDate.getTime() && crewCreatedDate.getTime() <= endDate.getTime();
      });
    } else if (period === 'Last 6 Months') {
      let startDate = new Date();
      startDate = new Date(startDate.setMonth(startDate.getMonth() - 6));
      this.crewRatings = this.intialRatings.filter(rating => {
        const crewCreatedDate = new Date(rating.createdAt);
        return crewCreatedDate.getTime() >= startDate.getTime() && crewCreatedDate.getTime() <= endDate.getTime();
      });
    } else if (period === 'Last 1 Year') {
      let startDate = new Date();
      startDate = new Date(startDate.setMonth(startDate.getMonth() - 12));
      this.crewRatings = this.intialRatings.filter(rating => {
        const crewCreatedDate = new Date(rating.createdAt);
        return crewCreatedDate.getTime() >= startDate.getTime() && crewCreatedDate.getTime() <= endDate.getTime();
      });
    } else {
      this.crewRatings = [...this.intialRatings];
    }

    this.setMasterInfo(this.crewRatings);
  }

  onSelectRank(event: any) {
    this.rank = event.srcElement.value;
    this.fetchCrewRatings(this.crewId);
    this.listCrewRating(this.crewId);
  }

  setMasterInfo(filteredRatings: any[]) {
    let aveRatings = 0;
    const shipsSet = new Set();
    filteredRatings.forEach(rating => {
      aveRatings += rating.finalRating;
      shipsSet.add(rating.vesselName);
    });
    this.noOfReports = filteredRatings.length;
    this.noOfShips = shipsSet.size;
    this.averageRating = aveRatings / this.noOfReports;
  }

  onAddPDF(crewRatings) {
    console.log('On Add pdf crewratings',crewRatings);
    this.getCrewRatingListPDF(crewRatings);
    let avgSafetyRating = this.averageRating == 0 ? '-' : parseFloat(this.averageRating).toFixed(2);
    let crewObj = {
      crewId: ' ' + this.crewId,
      crewName: ' ' + this.crewName,
      Rank: ' ' + this.rank,
      Department: ' ' + this.department,
      Category: ' ' + this.category,
      no_of_reports: ' ' + this.noOfReports,
      no_of_ships: ' ' + this.noOfShips,
      avgRating: ' ' + avgSafetyRating,
      featureName: 'Analytics',
    }
    let doc = new jsPDF('p', 'mm', 'a4')
    if (!this.analyticsService.isChartView) {
      autoTable(doc, {
        head: this.head,
        headStyles: {
          halign: 'left'
        },        
        styles: {
          halign: 'left',
        },
        columnStyles: {
          3: {halign: 'center'},
        },
        margin: { top: 80, left: 5, right: 5 },
        body: this.tableData,
        didParseCell: (data) => {
          if (data.section === 'head') {
            data.cell.styles.textColor = 'black'
            data.row.cells[3].styles.halign = 'center'
          }          
          data.cell.styles.lineWidth = 0.3;
          data.cell.styles.fillColor = '#ffffff'
          data.cell.styles.lineColor = '#E8E8E8'
        },
      })
      doc.setFontSize(13);
      doc = this.filterService.addHeaderAndFooterAnalytics(doc, crewObj);
      //doc.setFontType('bold');
      doc.text('Individual Rating Detail - Full Record', 70, 30);     //report name
      doc = this.filterService.addRatingDescription(doc);        //method for adding ratings description on PDF
      doc.save('Individual-Rating-Detail - Full Record.pdf'); // Generated PDF   
    } else {
      const content = this.lineChart.nativeElement;
      html2canvas(content).then(canvas => {
        // Few necessary setting options  
        var imgWidth = 200;
        var pageHeight = 400;
        var imgHeight = canvas.height * imgWidth / canvas.width;
        var heightLeft = imgHeight;

        const contentDataURL = canvas.toDataURL('image/png')
        var position = 100;
        doc.addImage(contentDataURL, 'PNG', 5, position, imgWidth, imgHeight);
        doc.setFontSize(13);
        doc = this.filterService.addHeaderAndFooterAnalytics(doc, crewObj);
        doc.setFontType('bold');
        doc.text('Individual Rating Detail - Line Chart', 70, 30);  //report name
        this.addRatingDescription(doc);                             //method for adding ratings description on PDF
        doc.save('Individual-Rating-Detail - Line Chart.pdf'); // Generated PDF  
      });

    }
  }

  addRatingDescription(pdfObject) {
    var number_of_pages = pdfObject.internal.getNumberOfPages();
    var pdf_pages = pdfObject.internal.pages;
    for (var i = 1; i < pdf_pages.length; i++) {
      if (i == number_of_pages) {
        pdfObject.setFontSize(10)
        pdfObject.setFontType('unbold');
        pdfObject.text(' Unsatisfied', 10, 155);
        pdfObject.text(' Needs Improvements', 10, 160);
        pdfObject.text(' Meets Expectations', 10, 165);
        pdfObject.text(' Exceeds Expectations', 10, 170);
        pdfObject.text(' Exceptional', 10, 175);
        pdfObject.setFontType('bold');
        pdfObject.text('Rating Scale:-', 5, 150);
        pdfObject.text('1 :', 5, 155);
        pdfObject.text('2 :', 5, 160);
        pdfObject.text('3 :', 5, 165);
        pdfObject.text('4 :', 5, 170);
        pdfObject.text('5 :', 5, 175);
      }
    }
  }

  openMail(crewRatings) {
    this.getCrewRatingListPDF(crewRatings);
    let avgSafetyRating = this.averageRating == 0 ? '-' : parseFloat(this.averageRating).toFixed(2);
    let crewObj = {
      crewId: ' ' + this.crewId,
      crewName: ' ' + this.crewName,
      Rank: ' ' + this.rank,
      Department: ' ' + this.department,
      Category: ' ' + this.category,
      no_of_reports: ' ' + this.noOfReports,
      no_of_ships: ' ' + this.noOfShips,
      avgRating: ' ' + avgSafetyRating,
      featureName: 'Analytics',
    }
    let doc = new jsPDF('p', 'mm', 'a4')
    if (!this.analyticsService.isChartView) {
      autoTable(doc, {
        head: this.head,
        headStyles: {
          halign: 'left'
        },        
        styles: {
          halign: 'left',
        },
        columnStyles: {
          3: {halign: 'center'},
        },
        margin: { top: 80, left: 5, right: 5 },
        body: this.tableData,
        didParseCell: (data) => {
          if (data.section === 'head') {
            data.cell.styles.textColor = 'black'
            data.row.cells[3].styles.halign = 'center'
          }          
          data.cell.styles.lineWidth = 0.3;
          data.cell.styles.fillColor = '#ffffff'
          data.cell.styles.lineColor = '#E8E8E8'
        },
      })
      doc.setFontSize(13);
      doc = this.filterService.addHeaderAndFooterAnalytics(doc, crewObj);
      //doc.setFontType('bold');
      doc.text('Individual Rating Detail - Full Record', 70, 30);     //report name
      doc = this.filterService.addRatingDescription(doc);        //method for adding ratings description on PDF
      const pdfBase64CrewRatingDetailList = doc.output('datauristring');
      
      this.customDialogService.showDialog('Do you want to email the pdf file of this screen?','yes').subscribe(actionType => {
        console.log('actionType ',actionType);
        if(actionType === 'yes'){
          this.appSpinner.show();
          this.crewService.sendEmailToUser('Rating_Detail_Full_Record.pdf', pdfBase64CrewRatingDetailList).subscribe((data: any)=>{
            if(data){
              console.log('sucessfull ',data);
              this.appSpinner.hide();
              this.customDialogService.showDialog(data.message, 'dismiss');
            }
          }); 
        }
        else{
  
        }
      })
    } else {
      const content = this.lineChart.nativeElement;
      html2canvas(content).then(canvas => {
        // Few necessary setting options  
        var imgWidth = 200;
        var pageHeight = 400;
        var imgHeight = canvas.height * imgWidth / canvas.width;
        var heightLeft = imgHeight;

        const contentDataURL = canvas.toDataURL('image/png')
        var position = 100;
        doc.addImage(contentDataURL, 'PNG', 5, position, imgWidth, imgHeight);
        doc.setFontSize(13);
        doc = this.filterService.addHeaderAndFooterAnalytics(doc, crewObj);
        doc.setFontType('bold');
        doc.text('Individual Rating Detail - Line Chart', 70, 30);  //report name
        this.addRatingDescription(doc);                             //method for adding ratings description on PDF
        const pdfBase64CrewRatingDetailChart = doc.output('datauristring');
       
        this.customDialogService.showDialog('Do you want to send the pdf file of this screen?','yes').subscribe(actionType => {
          console.log('actionType ',actionType);
          if(actionType === 'yes'){
            this.appSpinner.show();
            this.crewService.sendEmailToUser('Rating_Detail_Line_Chart.pdf', pdfBase64CrewRatingDetailChart).subscribe((data: any)=>{
              if(data){
                console.log('sucessfull ',data);
                this.appSpinner.hide();
                this.customDialogService.showDialog(data.message, 'dismiss');
              }
            }); 
          }
          else{
    
          }
        })

      });

    }
  }

  goBack() {
    if (!this.analyticsService.isChartView) {
      this.suggestedcrewMemberListLength = 0;
      this.analyticsService.isChartView = true;
    } else {
      this.suggestedcrewMemberListLength = 0;
      // this.location.back();
      // this.location.back();
      this.router.navigate([`analytics`]);
    }
  }

  ngOnDestroy(){
    this.analyticsService.isChartView = true;
  }

  ratingScale() {
    this.customDialogService.showRatingScaleDialogue(AppConstant.Rating_Scale,'ratingScale');
  }

}